"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqType = exports.ContactType = exports.ConnectTo = exports.ShiftType = exports.ShiftMode = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["CONTINUE"] = "continue";
    ActionType["REDIRECT"] = "redirect";
    ActionType["SEND_SMS"] = "sendSMS";
    ActionType["CONTACT_PERSON"] = "contactPerson";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ShiftMode;
(function (ShiftMode) {
    ShiftMode[ShiftMode["INCOMING_CALL"] = 0] = "INCOMING_CALL";
    ShiftMode[ShiftMode["ERROR"] = 1] = "ERROR";
    ShiftMode[ShiftMode["REDIRECT"] = 2] = "REDIRECT";
    ShiftMode[ShiftMode["EDIT_RESA"] = 3] = "EDIT_RESA";
    ShiftMode[ShiftMode["EVENT"] = 4] = "EVENT";
})(ShiftMode = exports.ShiftMode || (exports.ShiftMode = {}));
var ShiftType;
(function (ShiftType) {
    ShiftType[ShiftType["WDAYS"] = 0] = "WDAYS";
    ShiftType[ShiftType["DATES"] = 1] = "DATES";
    ShiftType[ShiftType["TS"] = 2] = "TS";
})(ShiftType = exports.ShiftType || (exports.ShiftType = {}));
var ConnectTo;
(function (ConnectTo) {
    ConnectTo[ConnectTo["REDIRECT"] = 0] = "REDIRECT";
    ConnectTo[ConnectTo["ASSISTANT"] = 1] = "ASSISTANT";
    ConnectTo[ConnectTo["VOICE_MAIL"] = 2] = "VOICE_MAIL";
    ConnectTo[ConnectTo["TEXT_MESSAGE"] = 3] = "TEXT_MESSAGE";
    ConnectTo[ConnectTo["VOICE_MESSAGE"] = 4] = "VOICE_MESSAGE";
})(ConnectTo = exports.ConnectTo || (exports.ConnectTo = {}));
var ContactType;
(function (ContactType) {
    ContactType[ContactType["GENERAL"] = 0] = "GENERAL";
    ContactType[ContactType["RESERVATION"] = 1] = "RESERVATION";
    ContactType[ContactType["EVENT"] = 2] = "EVENT";
    ContactType[ContactType["ERROR"] = 3] = "ERROR";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
var FaqType;
(function (FaqType) {
    FaqType[FaqType["OPENING_HOURS"] = 0] = "OPENING_HOURS";
    FaqType[FaqType["CORONA"] = 1] = "CORONA";
    FaqType[FaqType["EVENTS"] = 2] = "EVENTS";
    FaqType[FaqType["DOG"] = 3] = "DOG";
    FaqType[FaqType["KIDS"] = 4] = "KIDS";
    FaqType[FaqType["JOB_OFFERS"] = 5] = "JOB_OFFERS";
    FaqType[FaqType["TAKE_AWAY"] = 6] = "TAKE_AWAY";
    FaqType[FaqType["OTHER"] = 7] = "OTHER";
})(FaqType = exports.FaqType || (exports.FaqType = {}));
